'use client';
var compare = function(prev, current) {
    return prev.map(function(v, i) {
        return v === current[i];
    }).indexOf(false) < 0;
};

export { compare };
